import config from '../config';

// keep binding between css values and js
export const deviceResolutions = {
    mobile: 500,
    tablet: 768,
    smallDesktop: 920,
    desktop: 1084
};

export const FIXED_SIDEBAR_WIDTH = 72;

export const importedProjectTypes = ['netlify', 'googledocs'];

export const CONTACT_SALES_URL = new URL('contact-sales', config.marketingSite.url).toString();

export const CONTACT_SALES_MAIL = new URL('mailto:sales@stackbit.com').toString();

export const CONTACT_SUPPORT_URL = 'https://www.netlify.com/support/';

export enum ReferrerTypes {
    WizardDeploy = 'deploy',
    Dashboard = 'dashboard',
    ImportDeploy = 'importDeploy',
    CustomThemeDeploy = 'customThemeDeploy'
}
